// import '../scss/components/_ownerreports.scss'
// import React, { useState, useEffect, useMemo } from 'react'
// import { get_occupancy_status } from '../apis/services/pgApi'

// // ─── Constants ───────────────────────────────────────────────────────────────

// const MONTHS = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec']

// // ─── Shared helpers ──────────────────────────────────────────────────────────

// function getHealthSummary(avg, totalBeds) {
//   const percentage = totalBeds > 0 ? (avg / totalBeds) * 100 : 0
//   if (percentage >= 85) return { text: 'Outstanding occupancy', tag: 'excellent' }
//   if (percentage >= 75) return { text: 'Excellent occupancy',   tag: 'excellent' }
//   if (percentage >= 65) return { text: 'Healthy occupancy',     tag: 'healthy'   }
//   if (percentage >= 50) return { text: 'Needs improvement',     tag: 'needs-improvement' }
//   return           { text: 'Attention required',         tag: 'attention' }
// }

// function StatTile({ label, value, sub, accent }) {
//   return (
//     <div className="rpt-stat-tile" style={{ borderTopColor: accent }}>
//       <span className="rpt-stat-value" style={{ color: accent }}>{value}</span>
//       <span className="rpt-stat-label">{label}</span>
//       {sub && <span className="rpt-stat-sub">{sub}</span>}
//     </div>
//   )
// }

// // ─── Occupancy Month Accordion ──────────────────────────────────────────────

// function OccupancyMonthAccordion({ occupancyData, selectedYear }) {
//   const [expandedYears, setExpandedYears] = useState(() => ({
//     [selectedYear]: true
//   }))

//   const [expandedMonths, setExpandedMonths] = useState(() => ({
//     [`${selectedYear}-Jan`]: true
//   }))

//   const toggleYear = (year) => {
//     setExpandedYears(prev => ({
//       ...prev,
//       [year]: !prev[year]
//     }))
//   }

//   const toggleMonth = (key) => {
//     setExpandedMonths(prev => ({
//       ...prev,
//       [key]: !prev[key]
//     }))
//   }

//   // Get available years from data
//   const availableYears = Object.keys(occupancyData)
//     .map(Number)
//     .sort((a, b) => b - a) // Descending (latest first)

//   // Room type mapping
//   const roomTypeMap = {
//     'single': 'Single',
//     'double': 'Double',
//     'triple': 'Triple',
//     'quad': 'Quad',
//     'dorm': 'Dorm'
//   }

//   return (
//     <div className="rpt-occupancy-accordion">
//       <h3 className="rpt-accordion-title">Month Wise Occupancy</h3>
      
//       {availableYears.map(year => {
//         const yearData = occupancyData[year] || {}
//         const isYearExpanded = expandedYears[year] || false
//         const yearMonths = Object.keys(yearData)
//         const totalOccupants = Object.values(yearData).reduce(
//           (sum, monthData) => sum + (monthData?.length || 0), 0
//         )

//         return (
//           <div key={year} className="rpt-year-accordion">
//             <button 
//               className="rpt-year-toggle"
//               onClick={() => toggleYear(year)}
//             >
//               <span className="rpt-accordion-chevron">
//                 {isYearExpanded ? '▼' : '▶'}
//               </span>
//               <span className="rpt-year-label">{year}</span>
//               <span className="rpt-year-count">({totalOccupants} occupants)</span>
//             </button>

//             {isYearExpanded && (
//               <div className="rpt-year-content">
//                 {yearMonths.map(month => {
//                   const monthData = yearData[month] || []
//                   const monthKey = `${year}-${month}`
//                   const isMonthExpanded = expandedMonths[monthKey] || false

//                   return (
//                     <div key={month} className="rpt-month-accordion">
//                       <button 
//                         className="rpt-month-toggle"
//                         onClick={() => toggleMonth(monthKey)}
//                       >
//                         <span className="rpt-accordion-chevron">
//                           {isMonthExpanded ? '▼' : '▶'}
//                         </span>
//                         <span className="rpt-month-label">{month}</span>
//                         <span className="rpt-month-count">({monthData.length} occupants)</span>
//                       </button>

//                       {isMonthExpanded && (
//                         <div className="rpt-month-content">
//                           {monthData.length > 0 ? (
//                             <table className="rpt-occupancy-table">
//                               <thead>
//                                 <tr>
//                                   <th>S.No</th>
//                                   <th>Tenant Name</th>
//                                   <th>Room Type</th>
//                                   <th>Room Number</th>
//                                   <th>Bed Number</th>
//                                   <th>Joining Date</th>
//                                   <th>Exit Date</th>
//                                 </tr>
//                               </thead>
//                               <tbody>
//                                 {monthData.map((occupant, index) => (
//                                   <tr key={index}>
//                                     <td>{index + 1}</td>
//                                     <td>{occupant.tenantName}</td>
//                                     <td>{roomTypeMap[occupant.roomType] || occupant.roomType}</td>
//                                     <td>{occupant.roomNumber}</td>
//                                     <td>{occupant.bedNumber}</td>
//                                     <td>{occupant.joiningDate}</td>
//                                     <td>{occupant.exitDate || '—'}</td>
//                                   </tr>
//                                 ))}
//                               </tbody>
//                             </table>
//                           ) : (
//                             <p className="rpt-empty-message">No occupants this month</p>
//                           )}
//                         </div>
//                       )}
//                     </div>
//                   )
//                 })}
//               </div>
//             )}
//           </div>
//         )
//       })}
//     </div>
//   )
// }

// // ─── Main Component ──────────────────────────────────────────────────────────

// const OwnerOccupancyReport = ({ selectedPGId, selectedPG, dateFrom, dateTo, selectedYear, mockMonthlyData }) => {
//   const [bedData, setBedData] = useState([])
//   const [loading, setLoading] = useState(true)
//   const [error,   setError]   = useState(null)
//   const [target,  setTarget]  = useState(7) // Default target: 70% of 10 beds

//   const { year: currentYear, month: currentMonth } = useMemo(() => {
//     const d = new Date(dateTo)
//     return { year: d.getFullYear(), month: d.getMonth() + 1 }
//   }, [dateTo])

//   useEffect(() => {
//     if (!selectedPGId) return
//     setLoading(true)
//     setError(null)
//     get_occupancy_status(selectedPGId)
//       .then(response => {
//         let beds = []
//         if (Array.isArray(response)) {
//           beds = response.length >= 1 ? response[0] : response
//         } else if (response?.data) {
//           beds = response.data
//         } else {
//           beds = response || []
//         }
//         setBedData(beds)
//       })
//       .catch(err => setError(err.message || 'Failed to load'))
//       .finally(() => setLoading(false))
//   }, [selectedPGId])

//   const bedStats = useMemo(() => {
//     const total    = bedData.length
//     const occupied = bedData.filter(b => (b.OccupancyStatus || '').toUpperCase() === 'OCCUPIED').length
//     const notice   = bedData.filter(b => (b.OccupancyStatus || '').toUpperCase() === 'NOTICE').length
//     const vacant   = total - occupied - notice
//     const rate     = total ? ((occupied / total) * 100) : 0
//     return { total, occupied, notice, vacant, rate: Math.round(rate * 10) / 10 }
//   }, [bedData])

//   // ─── Monthly occupancy counts (actual numbers based on total beds) ────────────
//   const monthlyData = useMemo(() => {
//     const totalBeds = bedStats.total || 10; // Use actual total beds from API
    
//     // Generate realistic occupancy counts based on total beds
//     // These should never exceed totalBeds
//     const generateMonthlyData = (baseYear) => {
//       // Different patterns for different years
//       if (baseYear === 2026) {
//         return [
//           Math.min(Math.round(totalBeds * 0.7), totalBeds),  // Jan - 70%
//           Math.min(Math.round(totalBeds * 0.75), totalBeds), // Feb - 75%
//           Math.min(Math.round(totalBeds * 0.8), totalBeds),  // Mar - 80%
//           Math.min(Math.round(totalBeds * 0.85), totalBeds), // Apr - 85%
//           Math.min(Math.round(totalBeds * 0.9), totalBeds),  // May - 90%
//           Math.min(Math.round(totalBeds * 0.95), totalBeds), // Jun - 95%
//           Math.min(Math.round(totalBeds * 0.9), totalBeds),  // Jul - 90%
//           Math.min(Math.round(totalBeds * 0.85), totalBeds), // Aug - 85%
//           Math.min(Math.round(totalBeds * 0.8), totalBeds),  // Sep - 80%
//           Math.min(Math.round(totalBeds * 0.75), totalBeds), // Oct - 75%
//           Math.min(Math.round(totalBeds * 0.7), totalBeds),  // Nov - 70%
//           Math.min(Math.round(totalBeds * 0.65), totalBeds), // Dec - 65%
//         ]
//       } else if (baseYear === 2025) {
//         return [
//           Math.min(Math.round(totalBeds * 0.6), totalBeds),
//           Math.min(Math.round(totalBeds * 0.65), totalBeds),
//           Math.min(Math.round(totalBeds * 0.7), totalBeds),
//           Math.min(Math.round(totalBeds * 0.75), totalBeds),
//           Math.min(Math.round(totalBeds * 0.8), totalBeds),
//           Math.min(Math.round(totalBeds * 0.85), totalBeds),
//           Math.min(Math.round(totalBeds * 0.8), totalBeds),
//           Math.min(Math.round(totalBeds * 0.75), totalBeds),
//           Math.min(Math.round(totalBeds * 0.7), totalBeds),
//           Math.min(Math.round(totalBeds * 0.65), totalBeds),
//           Math.min(Math.round(totalBeds * 0.6), totalBeds),
//           Math.min(Math.round(totalBeds * 0.55), totalBeds),
//         ]
//       } else {
//         return [
//           Math.min(Math.round(totalBeds * 0.5), totalBeds),
//           Math.min(Math.round(totalBeds * 0.55), totalBeds),
//           Math.min(Math.round(totalBeds * 0.6), totalBeds),
//           Math.min(Math.round(totalBeds * 0.65), totalBeds),
//           Math.min(Math.round(totalBeds * 0.7), totalBeds),
//           Math.min(Math.round(totalBeds * 0.75), totalBeds),
//           Math.min(Math.round(totalBeds * 0.7), totalBeds),
//           Math.min(Math.round(totalBeds * 0.65), totalBeds),
//           Math.min(Math.round(totalBeds * 0.6), totalBeds),
//           Math.min(Math.round(totalBeds * 0.55), totalBeds),
//           Math.min(Math.round(totalBeds * 0.5), totalBeds),
//           Math.min(Math.round(totalBeds * 0.45), totalBeds),
//         ]
//       }
//     }

//     return {
//       2026: generateMonthlyData(2026),
//       2025: generateMonthlyData(2025),
//       2024: generateMonthlyData(2024),
//     }
//   }, [bedStats.total])

//   const rawYearData  = monthlyData[selectedYear] || Array(12).fill(null)
//   const maxMonth     = (selectedYear === currentYear) ? currentMonth : 12
//   const yearData     = rawYearData.map((val, idx) => (idx + 1 > maxMonth ? null : val))

//   const validData  = yearData.filter(v => v !== null && v !== undefined)
//   const currentAvg = validData.length > 0 ? validData.reduce((a, b) => a + b, 0) / validData.length : 0
//   const prevYearData = monthlyData[selectedYear - 1] || Array(12).fill(null)
//   const prevValid    = prevYearData.filter(v => v !== null && v !== undefined)
//   const prevAvg      = prevValid.length > 0 ? prevValid.reduce((a, b) => a + b, 0) / prevValid.length : 0
//   const vsPrev       = currentAvg - prevAvg

//   const peakVal    = validData.length > 0 ? Math.max(...validData) : 0
//   const peakIdx    = yearData.indexOf(peakVal)
//   const peakMonth  = peakIdx >= 0 ? MONTHS[peakIdx] : '—'
//   const lowestVal  = validData.length > 0 ? Math.min(...validData) : 0
//   const lowestIdx  = yearData.indexOf(lowestVal)
//   const lowestMonth = lowestIdx >= 0 ? MONTHS[lowestIdx] : '—'
//   const maxValue   = validData.length > 0 ? Math.max(...validData) : 1

//   const health    = getHealthSummary(currentAvg, bedStats.total)
//   const healthTag = health.tag

//   const getBarClass = (val) => {
//     if (val === null || val === undefined) return 'rpt-bar-future'
//     return val >= target ? 'rpt-bar-met' : 'rpt-bar-missed'
//   }

//   // ─── Mock occupancy data for accordion ────────────────────────────────────

//   const occupancyData = useMemo(() => {
//     const totalBeds = bedStats.total || 10;
//     const mockData = {
//       2026: {
//         'January': [
//           { tenantName: 'Rahul Sharma', roomType: 'single', roomNumber: '101', bedNumber: '01', joiningDate: '02 Jan 2026', exitDate: null },
//           { tenantName: 'Sneha Patel', roomType: 'double', roomNumber: '102', bedNumber: '01', joiningDate: '05 Jan 2026', exitDate: '18 Jan 2026' },
//           { tenantName: 'Arjun Rao', roomType: 'dorm', roomNumber: '201', bedNumber: '01', joiningDate: '08 Jan 2026', exitDate: null },
//           { tenantName: 'Priya Nair', roomType: 'single', roomNumber: '103', bedNumber: '01', joiningDate: '12 Jan 2026', exitDate: null },
//           { tenantName: 'Vikram Singh', roomType: 'triple', roomNumber: '202', bedNumber: '01', joiningDate: '15 Jan 2026', exitDate: '28 Jan 2026' },
//         ],
//         'February': [
//           { tenantName: 'Meena Dasari', roomType: 'double', roomNumber: '104', bedNumber: '02', joiningDate: '01 Feb 2026', exitDate: null },
//           { tenantName: 'Kiran Menon', roomType: 'single', roomNumber: '105', bedNumber: '01', joiningDate: '03 Feb 2026', exitDate: null },
//           { tenantName: 'Deepak Joshi', roomType: 'quad', roomNumber: '203', bedNumber: '02', joiningDate: '07 Feb 2026', exitDate: '20 Feb 2026' },
//         ],
//         'March': [
//           { tenantName: 'Ananya Singh', roomType: 'single', roomNumber: '106', bedNumber: '01', joiningDate: '02 Mar 2026', exitDate: null },
//           { tenantName: 'Suresh Iyer', roomType: 'double', roomNumber: '107', bedNumber: '01', joiningDate: '05 Mar 2026', exitDate: null },
//         ],
//         'April': [],
//         'May': [
//           { tenantName: 'Rahul Sharma', roomType: 'single', roomNumber: '101', bedNumber: '01', joiningDate: '01 May 2026', exitDate: null },
//           { tenantName: 'Pooja Gupta', roomType: 'dorm', roomNumber: '201', bedNumber: '02', joiningDate: '03 May 2026', exitDate: null },
//           { tenantName: 'Naveen Pillai', roomType: 'double', roomNumber: '108', bedNumber: '02', joiningDate: '07 May 2026', exitDate: '15 May 2026' },
//           { tenantName: 'Sonia Agarwal', roomType: 'single', roomNumber: '109', bedNumber: '01', joiningDate: '10 May 2026', exitDate: null },
//         ],
//         'June': [
//           { tenantName: 'Ravi Kumar', roomType: 'triple', roomNumber: '204', bedNumber: '02', joiningDate: '01 Jun 2026', exitDate: null },
//           { tenantName: 'Amit Verma', roomType: 'single', roomNumber: '110', bedNumber: '01', joiningDate: '04 Jun 2026', exitDate: null },
//         ],
//       },
//       2025: {
//         'January': [
//           { tenantName: 'Rahul Sharma', roomType: 'single', roomNumber: '101', bedNumber: '01', joiningDate: '05 Jan 2025', exitDate: '20 Jan 2025' },
//           { tenantName: 'Sneha Patel', roomType: 'double', roomNumber: '102', bedNumber: '01', joiningDate: '08 Jan 2025', exitDate: null },
//         ],
//         'February': [
//           { tenantName: 'Arjun Rao', roomType: 'dorm', roomNumber: '201', bedNumber: '01', joiningDate: '02 Feb 2025', exitDate: null },
//         ],
//       },
//       2024: {
//         'January': [
//           { tenantName: 'Priya Nair', roomType: 'single', roomNumber: '103', bedNumber: '01', joiningDate: '10 Jan 2024', exitDate: '25 Jan 2024' },
//         ],
//       }
//     }
//     return mockData
//   }, [bedStats.total])

//   if (loading) return <div className="rpt-state">Loading occupancy data…</div>
//   if (error)   return <div className="rpt-state rpt-state-error">Error: {error}</div>

//   return (
//     <div className="rpt-section">

//       <div className="rpt-tiles">
//         <StatTile label="Total Beds"    value={bedStats.total}    accent="#6366F1" />
//         <StatTile label="Occupied"      value={bedStats.occupied} sub={`${bedStats.rate}% fill rate`} accent="#22C55E" />
//         <StatTile label="Notice Period" value={bedStats.notice}   sub="Moving out soon" accent="#F59E0B" />
//         <StatTile label="Vacant"        value={bedStats.vacant}   sub="Available now"   accent="#EF4444" />
//       </div>

//       <div className="rpt-chart-grid">
//         <div className="rpt-chart-card">
//           <div className="rpt-chart-title">
//             <span>Monthly Occupancy • {selectedYear}</span>
//             <span className="sub">Target <strong>{target} beds</strong></span>
//           </div>
//           <div className="rpt-legend">
//             <span><span className="rpt-legend-dot met"></span> Met target</span>
//             <span><span className="rpt-legend-dot missed"></span> Below target</span>
//             <span><span className="rpt-legend-dot future"></span> No data yet</span>
//           </div>
//           <div className="rpt-barchart">
//             {yearData.map((val, i) => {
//               const isFuture = val === null || val === undefined
//               const isPeak   = !isFuture && val >= peakVal && val === peakVal
//               return (
//                 <div key={i} className="rpt-bar-col">
//                   <span className="rpt-bar-value">{isFuture ? '—' : val}</span>
//                   <div
//                     className={`rpt-bar ${getBarClass(val)}`}
//                     style={{ 
//                       height: isFuture ? '4px' : `${Math.max(4, (val / maxValue) * 100)}%` 
//                     }}
//                   >
//                     {isPeak && <span className="rpt-bar-peak-marker">▲</span>}
//                   </div>
//                   <span className="rpt-bar-label">{MONTHS[i]}</span>
//                 </div>
//               )
//             })}
//           </div>
//           <div className="rpt-target-section">
//             <div className="rpt-target-label">
//               Occupancy Target (beds)
//               <input
//                 type="number"
//                 className="rpt-target-input"
//                 value={target}
//                 onChange={e => setTarget(Math.min(bedStats.total, Math.max(1, Number(e.target.value) || 7)))}
//                 min={1} max={bedStats.total || 10}
//               />
//             </div>
//             <div className="rpt-target-meta">
//               <span>Above: <strong className="above">{validData.filter(v => v >= target).length}/{validData.length}</strong></span>
//               <span>Below: <strong className="below">{validData.filter(v => v < target).length}/{validData.length}</strong></span>
//             </div>
//           </div>
//         </div>

//         <div className="rpt-quarter-card">
//           <div className="rpt-quarter-label">Best Quarter</div>
//           <div className="rpt-quarter-value">
//             {(() => {
//               let bestQ = { label: '', avg: 0, range: '' }
//               for (let q = 0; q < 4; q++) {
//                 const start = q * 3
//                 const slice = yearData.slice(start, start + 3).filter(v => v !== null && v !== undefined)
//                 if (slice.length === 0) continue
//                 const avg = slice.reduce((a, b) => a + b, 0) / slice.length
//                 if (avg > bestQ.avg) {
//                   bestQ = { label: `Q${q + 1}`, avg: Math.round(avg * 10) / 10, range: `${MONTHS[start]}–${MONTHS[start + 2]}` }
//                 }
//               }
//               return bestQ.label || '—'
//             })()}
//           </div>
//           <div className="rpt-quarter-sub">
//             {(() => {
//               let bestQ = { label: '', avg: 0, range: '' }
//               for (let q = 0; q < 4; q++) {
//                 const start = q * 3
//                 const slice = yearData.slice(start, start + 3).filter(v => v !== null && v !== undefined)
//                 if (slice.length === 0) continue
//                 const avg = slice.reduce((a, b) => a + b, 0) / slice.length
//                 if (avg > bestQ.avg) {
//                   bestQ = { label: `Q${q + 1}`, avg: Math.round(avg * 10) / 10, range: `${MONTHS[start]}–${MONTHS[start + 2]}` }
//                 }
//               }
//               return bestQ.range ? `${bestQ.range} · ${bestQ.avg} avg beds` : 'No data'
//             })()}
//           </div>
//         </div>
//       </div>

//       <div className="rpt-health-card">
//         <div className="rpt-health-summary">
//           Average occupancy: <span className="highlight">{currentAvg.toFixed(0)}</span> beds occupied this year —
//           <span className={`rpt-health-tag ${healthTag}`}>{health.text}</span>.
//           {validData.length < 12 && ` (based on ${validData.length} months of data)`}
//         </div>
//         <div className="rpt-health-meta">
//           <span className="rpt-health-meta-item">Peak month: <strong>{peakMonth} – {peakVal} beds</strong></span>
//           <span className="rpt-health-meta-item">Lowest month: <strong>{lowestMonth} – {lowestVal} beds</strong></span>
//           <span className="rpt-health-meta-item">Average: <strong>{currentAvg.toFixed(0)} beds</strong></span>
//           <span className="rpt-health-meta-item">
//             vs {selectedYear - 1}: <strong className={vsPrev >= 0 ? 'up' : 'down'}>
//               {vsPrev >= 0 ? `+${vsPrev.toFixed(0)}` : `${vsPrev.toFixed(0)}`}
//             </strong>
//           </span>
//         </div>
//       </div>

//       {/* ── Month Wise Occupancy Accordion ── */}
//       <OccupancyMonthAccordion 
//         occupancyData={occupancyData} 
//         selectedYear={selectedYear}
//       />

//     </div>
//   )
// }

// export default OwnerOccupancyReport

import '../scss/components/_ownerreports.scss'
import React, { useState, useEffect, useMemo } from 'react'

// ─── Constants ───────────────────────────────────────────────────────────────

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

// ─── Shared helpers ──────────────────────────────────────────────────────────

function getHealthSummary(avg, totalBeds) {
  const percentage = totalBeds > 0 ? (avg / totalBeds) * 100 : 0
  if (percentage >= 85) return { text: 'Outstanding occupancy', tag: 'excellent' }
  if (percentage >= 75) return { text: 'Excellent occupancy', tag: 'excellent' }
  if (percentage >= 65) return { text: 'Healthy occupancy', tag: 'healthy' }
  if (percentage >= 50) return { text: 'Needs improvement', tag: 'needs-improvement' }
  return { text: 'Attention required', tag: 'attention' }
}

function StatTile({ label, value, sub, accent }) {
  return (
    <div className="rpt-stat-tile" style={{ borderTopColor: accent }}>
      <span className="rpt-stat-value" style={{ color: accent }}>{value}</span>
      <span className="rpt-stat-label">{label}</span>
      {sub && <span className="rpt-stat-sub">{sub}</span>}
    </div>
  )
}

// ─── Occupancy Month Accordion ──────────────────────────────────────────────

function OccupancyMonthAccordion({ tenantData, selectedYear }) {
  const [expandedYears, setExpandedYears] = useState(() => ({
    [selectedYear]: true
  }))

  const [expandedMonths, setExpandedMonths] = useState(() => {
    const firstMonth = Object.keys(tenantData[selectedYear] || {})[0]
    return firstMonth ? { [`${selectedYear}-${firstMonth}`]: true } : {}
  })

  const toggleYear = (year) => {
    setExpandedYears(prev => ({
      ...prev,
      [year]: !prev[year]
    }))
  }

  const toggleMonth = (key) => {
    setExpandedMonths(prev => ({
      ...prev,
      [key]: !prev[key]
    }))
  }

  // Get available years from data
  const availableYears = Object.keys(tenantData)
    .map(Number)
    .sort((a, b) => b - a) // Descending (latest first)

  // Get unique tenants count for a year (by AdmissionID)
  const getUniqueTenantsCount = (yearData) => {
    const uniqueIds = new Set()
    Object.values(yearData).forEach(monthData => {
      monthData.forEach(tenant => {
        if (tenant.AdmissionID) {
          uniqueIds.add(tenant.AdmissionID)
        }
      })
    })
    return uniqueIds.size
  }

  // Get total tenants count for a month (all entries, including duplicates if any)
  const getMonthTenantsCount = (monthData) => {
    return monthData.length
  }

  return (
    <div className="rpt-occupancy-accordion">
      <h3 className="rpt-accordion-title">Month Wise Occupancy</h3>

      {availableYears.map(year => {
        const yearData = tenantData[year] || {}
        const isYearExpanded = expandedYears[year] || false
        const yearMonths = Object.keys(yearData)
        const totalUniqueTenants = getUniqueTenantsCount(yearData)

        return (
          <div key={year} className="rpt-year-accordion">
            <button
              className="rpt-year-toggle"
              onClick={() => toggleYear(year)}
            >
              <span className="rpt-accordion-chevron">
                {isYearExpanded ? '▼' : '▶'}
              </span>
              <span className="rpt-year-label">{year}</span>
              <span className="rpt-year-count">({totalUniqueTenants} unique tenants)</span>
            </button>

            {isYearExpanded && (
              <div className="rpt-year-content">
                {yearMonths.map(month => {
                  const monthData = yearData[month] || []
                  const monthKey = `${year}-${month}`
                  const isMonthExpanded = expandedMonths[monthKey] || false
                  const monthTenantCount = getMonthTenantsCount(monthData)

                  return (
                    <div key={month} className="rpt-month-accordion">
                      <button
                        className="rpt-month-toggle"
                        onClick={() => toggleMonth(monthKey)}
                      >
                        <span className="rpt-accordion-chevron">
                          {isMonthExpanded ? '▼' : '▶'}
                        </span>
                        <span className="rpt-month-label">{month}</span>
                        <span className="rpt-month-count">({monthTenantCount} tenants)</span>
                      </button>

                      {isMonthExpanded && (
                        <div className="rpt-month-content">
                          {monthData.length > 0 ? (
                            <table className="rpt-occupancy-table">
                              <thead>
                                <tr>
                                  <th>S.No</th>
                                  <th>Tenant Name</th>
                                  <th>Room Type</th>
                                  <th>Room Number</th>
                                  <th>Bed Number</th>
                                  <th>Joining Date</th>
                                  <th>Exit Date</th>
                                  <th>Status</th>
                                </tr>
                              </thead>
                              <tbody>
                                {monthData.map((occupant, index) => (
                                  <tr key={index}>
                                    <td>{index + 1}</td>
                                    <td>{occupant.TenantName}</td>
                                    <td>—</td>
                                    <td>{occupant.RoomNumber}</td>
                                    <td>{occupant.BedNumber}</td>
                                    <td>{occupant.JoinDate ? new Date(occupant.JoinDate).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' }) : '—'}</td>
                                    <td>{occupant.ExitDate ? new Date(occupant.ExitDate).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' }) : '—'}</td>
                                    <td><span className={`rpt-status-badge ${(occupant.OccupancyStatus || '').toLowerCase()}`}>{occupant.OccupancyStatus || '—'}</span></td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          ) : (
                            <p className="rpt-empty-message">No occupants this month</p>
                          )}
                        </div>
                      )}
                    </div>
                  )
                })}
              </div>
            )}
          </div>
        )
      })}
    </div>
  )
}

// ─── Main Component ──────────────────────────────────────────────────────────

const OwnerOccupancyReport = ({ selectedPGId, selectedPG, dateFrom, dateTo, selectedYear }) => {
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const [target, setTarget] = useState(7) // Default target

  // API response data
  const [monthlyStats, setMonthlyStats] = useState([]) // First array - monthly summary
  const [tenantDetails, setTenantDetails] = useState([]) // Second array - tenant details
  const [overallStats, setOverallStats] = useState(null) // Third array - overall summary

  const { year: currentYear, month: currentMonth } = useMemo(() => {
    const d = new Date(dateTo)
    return { year: d.getFullYear(), month: d.getMonth() + 1 }
  }, [dateTo])

  // ─── Fetch occupancy report from API ──────────────────────────────────────

  useEffect(() => {
    if (!selectedPGId || !dateFrom || !dateTo) {
      setLoading(false)
      return
    }

    setLoading(true)
    setError(null)

    // Import the API function
    import('../apis/services/pgApi').then(({ getOccupancyReport }) => {
      getOccupancyReport(selectedPGId, dateFrom, dateTo)
        .then(response => {
          // Response is an array with 3 parts: [monthlyStats, tenantDetails, overallStats]
          if (Array.isArray(response) && response.length >= 3) {
            setMonthlyStats(response[0] || [])
            setTenantDetails(response[1] || [])
            setOverallStats(response[2]?.[0] || null)
          } else if (response?.data && Array.isArray(response.data)) {
            // Handle if response is wrapped in data property
            const data = response.data
            setMonthlyStats(data[0] || [])
            setTenantDetails(data[1] || [])
            setOverallStats(data[2]?.[0] || null)
          } else {
            setError('Unexpected API response format')
          }
        })
        .catch(err => {
          console.error('Error fetching occupancy report:', err)
          setError(err.message || 'Failed to load occupancy data')
        })
        .finally(() => setLoading(false))
    }).catch(err => {
      console.error('Error importing API:', err)
      setError('Failed to load API module')
      setLoading(false)
    })
  }, [selectedPGId, dateFrom, dateTo])

  // ─── Process bed statistics ───────────────────────────────────────────────

  const bedStats = useMemo(() => {
    if (!overallStats) {
      return { total: 0, occupied: 0, notice: 0, vacant: 0, rate: 0 }
    }

    const total = overallStats.TotalBeds || 0
    const occupied = overallStats.OccupiedBeds || 0
    const vacant = overallStats.VacantBeds || 0
    const rate = overallStats.OccupancyPercent || 0

    // Notice period tenants - calculate from tenantDetails where OccupancyStatus is 'NOTICE'
    const notice = tenantDetails.filter(t => 
      (t.OccupancyStatus || '').toUpperCase() === 'NOTICE'
    ).length

    return { total, occupied, notice, vacant, rate: Math.round(rate * 10) / 10 }
  }, [overallStats, tenantDetails])

  // ─── Monthly data for chart ───────────────────────────────────────────────

  const monthlyData = useMemo(() => {
    if (!monthlyStats || monthlyStats.length === 0) {
      return {}
    }

    // Group by year
    const grouped = {}
    monthlyStats.forEach(stat => {
      const monthYear = stat.Month || ''
      const parts = monthYear.split('-')
      if (parts.length === 2) {
        const year = parseInt(parts[1])
        const month = parts[0]
        if (!grouped[year]) grouped[year] = {}
        grouped[year][month] = stat.OccupiedBeds || 0
      }
    })

    return grouped
  }, [monthlyStats])

  // ─── Tenant data for accordion ────────────────────────────────────────────

  const tenantData = useMemo(() => {
    if (!tenantDetails || tenantDetails.length === 0) {
      return {}
    }

    const grouped = {}
    
    // For each tenant, we need to determine which months they were active
    tenantDetails.forEach(tenant => {
      const joinDate = tenant.JoinDate ? new Date(tenant.JoinDate) : null
      const exitDate = tenant.ExitDate ? new Date(tenant.ExitDate) : null
      
      if (!joinDate) return

      // If tenant has no exit date OR exit date is in the future, they are still active
      const isActive = !exitDate || exitDate >= new Date()
      
      // Determine the range of months this tenant should appear in
      const startYear = joinDate.getFullYear()
      const startMonth = joinDate.getMonth()
      
      // For active tenants, they should appear in all months from join date to current month
      // For vacated tenants, they should appear from join date to exit date (inclusive)
      let endYear = startYear
      let endMonth = startMonth
      
      if (isActive) {
        // Active tenant - show until current month
        const now = new Date()
        endYear = now.getFullYear()
        endMonth = now.getMonth()
      } else if (exitDate) {
        // Vacated tenant - show until exit date month
        endYear = exitDate.getFullYear()
        endMonth = exitDate.getMonth()
      }
      
      // Add tenant to each month they were active
      let currentYear = startYear
      let currentMonth = startMonth
      
      while (currentYear < endYear || (currentYear === endYear && currentMonth <= endMonth)) {
        const monthName = new Date(currentYear, currentMonth, 1).toLocaleString('default', { month: 'long' })
        
        if (!grouped[currentYear]) grouped[currentYear] = {}
        if (!grouped[currentYear][monthName]) grouped[currentYear][monthName] = []
        
        // Only add if not already in this month (avoid duplicates)
        const exists = grouped[currentYear][monthName].some(t => t.AdmissionID === tenant.AdmissionID)
        if (!exists) {
          grouped[currentYear][monthName].push(tenant)
        }
        
        // Move to next month
        currentMonth++
        if (currentMonth > 11) {
          currentMonth = 0
          currentYear++
        }
      }
    })

    // Sort tenants in each month by JoinDate (newest first)
    Object.keys(grouped).forEach(year => {
      Object.keys(grouped[year]).forEach(month => {
        grouped[year][month].sort((a, b) => {
          const dateA = a.JoinDate ? new Date(a.JoinDate) : new Date(0)
          const dateB = b.JoinDate ? new Date(b.JoinDate) : new Date(0)
          return dateB - dateA
        })
      })
    })

    return grouped
  }, [tenantDetails])

  // ─── Chart data for selected year ─────────────────────────────────────────

  const yearData = useMemo(() => {
    const currentYearData = monthlyData[selectedYear] || {}
    const maxMonth = (selectedYear === currentYear) ? currentMonth : 12

    return MONTHS.map((month, idx) => {
      const monthNum = idx + 1
      if (monthNum > maxMonth) return null
      return currentYearData[month] !== undefined ? currentYearData[month] : null
    })
  }, [monthlyData, selectedYear, currentYear, currentMonth])

  const validData = yearData.filter(v => v !== null && v !== undefined)
  const currentAvg = validData.length > 0 ? validData.reduce((a, b) => a + b, 0) / validData.length : 0

  // ─── Previous year comparison ─────────────────────────────────────────────

  const prevYearData = useMemo(() => {
    const prevYear = selectedYear - 1
    const prevData = monthlyData[prevYear] || {}
    return MONTHS.map(month => prevData[month] !== undefined ? prevData[month] : null)
  }, [monthlyData, selectedYear])

  const prevValid = prevYearData.filter(v => v !== null && v !== undefined)
  const prevAvg = prevValid.length > 0 ? prevValid.reduce((a, b) => a + b, 0) / prevValid.length : 0
  const vsPrev = currentAvg - prevAvg

  // ─── Peak and lowest ──────────────────────────────────────────────────────

  const peakVal = validData.length > 0 ? Math.max(...validData) : 0
  const peakIdx = yearData.indexOf(peakVal)
  const peakMonth = peakIdx >= 0 ? MONTHS[peakIdx] : '—'

  const lowestVal = validData.length > 0 ? Math.min(...validData) : 0
  const lowestIdx = yearData.indexOf(lowestVal)
  const lowestMonth = lowestIdx >= 0 ? MONTHS[lowestIdx] : '—'

  const maxValue = validData.length > 0 ? Math.max(...validData) : 1
  const health = getHealthSummary(currentAvg, bedStats.total || 10)
  const healthTag = health.tag

  const getBarClass = (val) => {
    if (val === null || val === undefined) return 'rpt-bar-future'
    return val >= target ? 'rpt-bar-met' : 'rpt-bar-missed'
  }

  if (loading) return <div className="rpt-state">Loading occupancy data…</div>
  if (error) return <div className="rpt-state rpt-state-error">Error: {error}</div>

  // Check if we have any data
  if (!overallStats && monthlyStats.length === 0 && tenantDetails.length === 0) {
    return <div className="rpt-state">No occupancy data available for the selected period</div>
  }

  return (
    <div className="rpt-section">

      <div className="rpt-tiles">
        <StatTile label="Total Beds" value={bedStats.total} accent="#6366F1" />
        <StatTile label="Occupied" value={bedStats.occupied} sub={`${bedStats.rate}% fill rate`} accent="#22C55E" />
        <StatTile label="Notice Period" value={bedStats.notice} sub="Moving out soon" accent="#F59E0B" />
        <StatTile label="Vacant" value={bedStats.vacant} sub="Available now" accent="#EF4444" />
      </div>

      <div className="rpt-chart-grid">
        <div className="rpt-chart-card">
          <div className="rpt-chart-title">
            <span>Monthly Occupancy • {selectedYear}</span>
            <span className="sub">Target <strong>{target} beds</strong></span>
          </div>
          <div className="rpt-legend">
            <span><span className="rpt-legend-dot met"></span> Met target</span>
            <span><span className="rpt-legend-dot missed"></span> Below target</span>
            <span><span className="rpt-legend-dot future"></span> No data yet</span>
          </div>
          <div className="rpt-barchart">
            {yearData.map((val, i) => {
              const isFuture = val === null || val === undefined
              return (
                <div key={i} className="rpt-bar-col">
                  <span className="rpt-bar-value">{isFuture ? '—' : val}</span>
                  <div
                    className={`rpt-bar ${getBarClass(val)}`}
                    style={{
                      height: isFuture ? '4px' : `${Math.max(4, (val / maxValue) * 100)}%`
                    }}
                  />
                  <span className="rpt-bar-label">{MONTHS[i]}</span>
                </div>
              )
            })}
          </div>
          <div className="rpt-target-section">
            <div className="rpt-target-label">
              Occupancy Target (beds)
              <input
                type="number"
                className="rpt-target-input"
                value={target}
                onChange={e => setTarget(Math.min(bedStats.total || 10, Math.max(1, Number(e.target.value) || 7)))}
                min={1} max={bedStats.total || 10}
              />
            </div>
            <div className="rpt-target-meta">
              <span>Above: <strong className="above">{validData.filter(v => v >= target).length}/{validData.length}</strong></span>
              <span>Below: <strong className="below">{validData.filter(v => v < target).length}/{validData.length}</strong></span>
            </div>
          </div>
        </div>

        <div className="rpt-quarter-card">
          <div className="rpt-quarter-label">Best Quarter</div>
          <div className="rpt-quarter-value">
            {(() => {
              let bestQ = { label: '', avg: 0, range: '' }
              for (let q = 0; q < 4; q++) {
                const start = q * 3
                const slice = yearData.slice(start, start + 3).filter(v => v !== null && v !== undefined)
                if (slice.length === 0) continue
                const avg = slice.reduce((a, b) => a + b, 0) / slice.length
                if (avg > bestQ.avg) {
                  bestQ = { label: `Q${q + 1}`, avg: Math.round(avg * 10) / 10, range: `${MONTHS[start]}–${MONTHS[start + 2]}` }
                }
              }
              return bestQ.label || '—'
            })()}
          </div>
          <div className="rpt-quarter-sub">
            {(() => {
              let bestQ = { label: '', avg: 0, range: '' }
              for (let q = 0; q < 4; q++) {
                const start = q * 3
                const slice = yearData.slice(start, start + 3).filter(v => v !== null && v !== undefined)
                if (slice.length === 0) continue
                const avg = slice.reduce((a, b) => a + b, 0) / slice.length
                if (avg > bestQ.avg) {
                  bestQ = { label: `Q${q + 1}`, avg: Math.round(avg * 10) / 10, range: `${MONTHS[start]}–${MONTHS[start + 2]}` }
                }
              }
              return bestQ.range ? `${bestQ.range} · ${bestQ.avg} avg beds` : 'No data'
            })()}
          </div>
        </div>
      </div>

      <div className="rpt-health-card">
        <div className="rpt-health-summary">
          Average occupancy: <span className="highlight">{currentAvg.toFixed(0)}</span> beds occupied this year —
          <span className={`rpt-health-tag ${healthTag}`}>{health.text}</span>.
          {validData.length < 12 && ` (based on ${validData.length} months of data)`}
        </div>
        <div className="rpt-health-meta">
          <span className="rpt-health-meta-item">Peak month: <strong>{peakMonth} – {peakVal} beds</strong></span>
          <span className="rpt-health-meta-item">Lowest month: <strong>{lowestMonth} – {lowestVal} beds</strong></span>
          <span className="rpt-health-meta-item">Average: <strong>{currentAvg.toFixed(0)} beds</strong></span>
          <span className="rpt-health-meta-item">
            vs {selectedYear - 1}: <strong className={vsPrev >= 0 ? 'up' : 'down'}>
              {vsPrev >= 0 ? `+${vsPrev.toFixed(0)}` : `${vsPrev.toFixed(0)}`}
            </strong>
          </span>
        </div>
      </div>

      {/* ── Month Wise Occupancy Accordion ── */}
      <OccupancyMonthAccordion
        tenantData={tenantData}
        selectedYear={selectedYear}
      />

    </div>
  )
}

export default OwnerOccupancyReport